import React from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Upload, Download, Plus } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

interface ListPageLayoutProps {
  title: string;
  search: string;
  onSearchChange: (v: string) => void;
  onAdd?: () => void;
  filters?: React.ReactNode;
  children: React.ReactNode;
  searchPlaceholder?: string;
  inlineFilters?: boolean;
  actionsExtra?: React.ReactNode;
  onImportClick?: () => void;
  onExportClick?: () => void;
}

export const ListPageLayout = ({ title, search, onSearchChange, onAdd, filters, children, searchPlaceholder, inlineFilters = false, actionsExtra, onImportClick, onExportClick }: ListPageLayoutProps) => {
  return (
    <section className="flex-1">
      <header className="sticky top-0 z-10 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 border-b border-border">
        {/* flex-wrap + min-w-0: sem isso o cabeçalho (título + busca fixa em
            w-64 + filtros + ações) estourava a largura e a PÁGINA inteira
            rolava de lado, no mobile e até no desktop das telas mais cheias. */}
        <div className="flex flex-wrap items-center justify-between gap-3 px-4 py-3">
          <div className="flex min-w-0 flex-1 flex-wrap items-center gap-3">
            <h1 className="text-xl font-semibold text-foreground">{title}</h1>
            <div className="w-full min-w-0 sm:w-64">
              <Input
                value={search}
                onChange={(e) => onSearchChange(e.target.value)}
                placeholder={searchPlaceholder ?? "Buscar..."}
                aria-label="Buscar"
              />
            </div>
            {inlineFilters && filters && (
              <div className="flex flex-wrap items-center gap-2">{filters}</div>
            )}
          </div>
          <div className="flex flex-wrap items-center gap-2">
            {actionsExtra}
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <Button variant="outline" size="sm" className="h-11 w-11 sm:h-9 sm:w-9" aria-label="Importar CSV/XLS" onClick={onImportClick}>
                    <Upload className="h-4 w-4" />
                  </Button>
                </TooltipTrigger>
                <TooltipContent className="bg-popover z-50">Importar</TooltipContent>
              </Tooltip>
            </TooltipProvider>
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <Button variant="outline" size="sm" className="h-11 w-11 sm:h-9 sm:w-9" aria-label="Exportar CSV/XLS" onClick={onExportClick}>
                    <Download className="h-4 w-4" />
                  </Button>
                </TooltipTrigger>
                <TooltipContent className="bg-popover z-50">Exportar</TooltipContent>
              </Tooltip>
            </TooltipProvider>
            {onAdd && (
              <Button onClick={onAdd} size="sm" className="h-11 sm:h-9">
                <Plus className="h-4 w-4" />
                Adicionar
              </Button>
            )}
          </div>
        </div>
        {!inlineFilters && filters && <div className="px-4 pb-3">{filters}</div>}
      </header>
      <main className="p-4">
        {children}
      </main>
    </section>
  );
};
